import { render, staticRenderFns } from "./ExamModeCard.vue?vue&type=template&id=687ddbda&"
import script from "./ExamModeCard.vue?vue&type=script&lang=ts&"
export * from "./ExamModeCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports